export const SET_SUB_CATEGORIES = 'SET_SUB_CATEGORIES';

export const setSubCategories = (subCategories) => {
  return {
    type: SET_SUB_CATEGORIES,
    payload: subCategories,
  };
};
